import { VendorDashboardService } from './../../../services/vendor-dashboard.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';
import saveAs from 'file-saver';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { first } from 'rxjs';

import { DepartmentAppVerificationModel } from 'src/app/models/department-app-verification.model';
import { BankDetail } from '../../registration/bank-details/bankDetails';
import { Table } from 'primeng/table';
import { TokenService } from 'src/app/services/common/token.service';
import { Dialog, DialogModule } from 'primeng/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import { IpAddressService } from 'src/app/services/ip-address.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { TranslateService } from '@ngx-translate/core';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';

@Component({
  selector: 'app-vendor-application',
  templateUrl: './vendor-application.component.html',
  styleUrls: ['./vendor-application.component.scss'],
})
export class VendorApplicationComponent implements OnInit {
  constructor(
    private route: ActivatedRoute, 
    private cryptoJsService: CryptoJsService, 
    private router: Router,
    private activityRecordService: ActivityRecordService
    ) { }


  items: any[];
  autoId: any;
  appId: any;

  activeItem: any;
  userID: any;

  ngOnInit() {
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;


    let parentRoute = this.router.url.split('/')[1];
    this.route.queryParams
      .subscribe(params => {
        this.autoId = params.autoId;
        this.appId = params.appId;
        this.items = [
          { label: 'Pending', routerLink: `/${parentRoute}/vendor-application/pending`},
          { label: 'Current', routerLink: `/${parentRoute}/vendor-application/current` },
          { label: 'Further Action Taken', routerLink: `/${parentRoute}/vendor-application/approved` },
          
        ];
      }
      );

  }
}

